/**
 * Placeholder for a participant search box. Only name is always included.
 * Pass true for a field when that column is visible for the current user.
 */
export const participantListingSearchPlaceholder = ({
  ndis = false,
  phone = false,
  email = false,
} = {}) => {
  const parts = ["Name"];
  if (ndis) parts.push("NDIS no.");
  if (phone) parts.push("phone");
  if (email) parts.push("email");
  if (parts.length === 1) return "Name";
  if (parts.length === 2) return `${parts[0]} or ${parts[1]}`;
  const last = parts[parts.length - 1];
  return `${parts.slice(0, -1).join(", ")} or ${last}`;
};
